import { useState, type ReactNode } from "react";

// Pieni ?-nappi joka avaa selittavaen help-modaalin per osio.
// Kayttoesi: <HelpButton title="..." > ...sisaeltoe... </HelpButton>

export type HelpButtonProps = {
  title: string;
  children: ReactNode;
  /** Aria-label, jos haluaa eri kuin "Apua: <title>". */
  ariaLabel?: string;
};

export function HelpButton({ title, children, ariaLabel }: HelpButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={ariaLabel ?? `Apua: ${title}`}
        className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-slate-700 bg-slate-800 text-xs font-bold text-slate-400 hover:bg-slate-700 hover:text-slate-100"
        title="Apua"
      >
        ?
      </button>
      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) setOpen(false);
          }}
        >
          <div className="w-full max-w-xl rounded-lg border border-slate-700 bg-slate-900 p-6 shadow-xl">
            <div className="flex items-start justify-between gap-3">
              <h3 className="text-lg font-semibold text-slate-100">{title}</h3>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Sulje"
                className="text-slate-400 hover:text-slate-100"
              >
                ✕
              </button>
            </div>
            <div className="mt-4 space-y-3 text-sm leading-relaxed text-slate-200">
              {children}
            </div>
            <div className="mt-6 flex justify-end">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="rounded bg-slate-100 px-4 py-2 text-sm font-medium text-slate-900 hover:bg-white"
              >
                Sulje
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/**
 * Helper-rivi: heading + ?-nappi vierekkain. Kayttoesi:
 *   <SectionHeader title="Source-rootit" help="<HelpContent>" />
 */
export function SectionHeader({
  title,
  help,
  helpTitle,
}: {
  title: string;
  help: ReactNode;
  /** HelpModal:n otsikko (default = title). */
  helpTitle?: string;
}) {
  return (
    <div className="flex items-center gap-2">
      <h3 className="text-lg font-semibold text-slate-100">{title}</h3>
      <HelpButton title={helpTitle ?? title}>{help}</HelpButton>
    </div>
  );
}
